/**
 * Heuristic: does this string look like it contains markdown formatting?
 * Used to auto-select the rich-text editor for static string defaults.
 */
export function looksLikeMarkdown(value: string): boolean {
  if (!value) return false;
  // headers, bold, unordered/ordered lists, links, blockquotes,
  // code fences/inline code, tables, horizontal rules
  return /(^|\n)\s{0,3}#{1,6}\s|\*\*[^*]+\*\*|(^|\n)\s*[-*+]\s|(^|\n)\s*\d+\.\s|\[[^\]]+\]\([^)]+\)|(^|\n)\s*>\s|```|`[^`]+`|(^|\n)\s*\|.+\||(^|\n)\s*(-{3,}|\*{3,})\s*($|\n)/.test(
    value,
  );
}
